module.exports = __webpack_public_path__ + "img/renshou@2x.9f2b25f2.png";